import { z } from 'zod';
import { atoneAuthPayment } from '@schemas/common-schemas/atone-common-schema';
import { allowEmpty, str, mandatoryStr } from '@schemas/common-schemas/schema-utils';

/**
 * atone都度後払い認証サービスのサービス分類子の実際のチェック項目。
 *
 * これを持ってして、どのサービスのパラメータかをまず判別する。
 */
const atoneAuthServiceRawParameterClassifierSchema = z.object({
  service_type: z.literal('01'),
  modal_mode: z.literal('02'),
});

/**
 * コールバック以外のServiceパラメータのバリデータ。
 *
 * コレは
 * - modal側で、会員サイト（ModalDriver）からのpostMessageで入力されたデータを検証、formatするために使用される。
 * - 会員サイト側のNpモジュールの型定義（.d.ts）の提供に使用される。
 *
 * 会員サイトからModalDriverへの入力チェックは `atoneAuthServiceParameterClassifierSchema` を使用し、service_typeとmodal_modeのみチェックする
 */
export const atoneAuthServiceParameterValidator = z.object({
  pub_key: mandatoryStr,
  ...atoneAuthServiceRawParameterClassifierSchema.shape,
  is_legacy: z.boolean().default(false),
  pre_token: allowEmpty(str),
  terminal_id: allowEmpty(str),
  payment: atoneAuthPayment,
  request_id: allowEmpty(str),
});

export type AtoneAuthServiceInputType = typeof atoneAuthServiceParameterValidator._input;

/**
 * atone都度後払い認証サービスのサービス分類子。
 *
 * これを持ってして、どのサービスのパラメータかを判別する。
 * チェック項目以外の全パラメータの型情報を付与も附与されている。
 */
export const atoneAuthServiceParameterClassifierSchema =
  atoneAuthServiceRawParameterClassifierSchema as unknown as typeof atoneAuthServiceParameterValidator;
